export const SET_RAW_VEHICLE_DATA = 'SET_RAW_VEHICLE_DATA'
export const SET_RAW_CROSS_SELLING_VEHICLE_DATA =
  'SET_RAW_CROSS_SELLING_VEHICLE_DATA'
export const SET_VEHICLE_FOUND_STATE = 'SET_VEHICLE_FOUND_STATE'
